module.exports = global["aos"] = require("-!/tmp/build/80754af9/workspace/themes/sfl-theme/node_modules/expose-loader/index.js?AOS!./aos.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/aos/dist/aos.js-exposed
// module id = 3
// module chunks = 1